import './interaction_view.js.coffee'
Customer.Ticket ||= {}

class Customer.Ticket.ChildInteractionView extends Customer.Ticket.InteractionView
  template: JST["backbone/templates/customer/ticket/body/child_interaction"]

  events:
    'click .child-like': 'onLike'
    'click .child-unlike': 'onUnlike'
    'click .child-show-context': 'showContext'
    'click .child-edit-tags-action' : 'editTags'
    'click .child-openResponseBox': 'openResponseBox'
    'click .text-with-html': 'switchToTextWithHtml'
    'click .text-without-html': 'switchToTextWithoutHtml'

  formContainerSelector: '.child-form-container'

  initialize: (@options = {}) ->
    super(@options)
    @model.set('isChild', true)

    @listenTo(@interaction, 'interaction:like', =>
      @$el.find('.child-like').addClass('hidden')
      @$el.find('.child-unlike').removeClass('hidden')
    )

    @listenTo(@interaction, 'interaction:unLike', =>
      @$el.find('.child-like').removeClass('hidden')
      @$el.find('.child-unlike').addClass('hidden')
    )

  ticketType: ->
    'child_interaction'

  onLike: ->
    @interaction.like()

  onUnlike: ->
    @interaction.unLike()

  openResponseBox: =>
    super responseTo: @options.parentInteraction.get('interaction_id')
